module.exports = __webpack_public_path__ + "assets/TituloEspecialidade.614e690e9abc16cbd648a671582e76c2.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/legenda/TituloEspecialidade.png
 ** module id = 484
 ** module chunks = 0
 **/